import { useState, useEffect } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";
import InputDecimal from "../../helpers/InputDecimal";
import InputTextArea from "../../helpers/InputTextArea";
import InputChecbox from "../../helpers/InputCheckbox";

import PlTitle from "../../elements/PlTitle";

import back from "../../back.png";
import InputTime from "../../helpers/InputTime";
import InputCombo from "../../helpers/InputCombo";
import InputDate from "../../helpers/InputDate";

function CalendarYearForm(props)
{

    

       const [errTab, setErrTab] = useState([]);  //z info od serwera..

    const [plgr, setPlGr] = useState(null);

       const [row, setRowX] = useState({
            id: -1,
            dzien: '',
            godzina_wydarzenia: '',
            temat_dnia: '',
            forma_aktywnosci: '',
            cel_dnia: '',
            uwagi_dodatkowe: '',
            wymagane: '',
            przypomnij_dzien_przed: '',
            data_wyslania_powidomienia: '',    
            grupy: [],
        });
        var tmpRow = row;


        const [checked, setChecked] = useState(false);
        const handleChange = () => {
            setChecked(!checked);
          };


        const valChecker = (fields) => {

            var allValid = true;
    
                  
            console.log(JSON.stringify(fields) );

            Object.entries(fields).forEach(function(entry) {
    
                var xKey    = entry[0];
                var xValue  = entry[1];                    

                var xValidName = xKey + "_valid";
    
                if(fields[xValidName] == false)
                {
                    allValid = false;
                    console.log("Error field: " + xKey);
                }
                
              });
            
              return allValid;
    
        }
    

            const valChangeListener = (filedName, val, correct, msg) => {         


                console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 


                var tabCheck = filedName.split('@');
                if(tabCheck.length == 2)
                {
                    var tabName = tabCheck[0];
                    var tabInx  = tabCheck[1];


                    
                            if(tabName == 'grupy')
                                {
                                    console.log("grupy", row.grupy);
                                    //console.log("plg", plgr.result);

                                    //sprawdzy czy klikniete id wystepuje w grupach,, tzn czy jest zaznaczone
                                    var isChecked = false;
                                    var newListGrupWithoutSelected = new Array();

                                    for(var kx=0; kx < row.grupy.length; kx++)
                                    {
                                        if( parseInt( row.grupy[kx]) == parseInt(val) ) { isChecked =true; continue; }

                                        newListGrupWithoutSelected.push(  "" + row.grupy[kx] + "" ); //wypełnij bez grupy znalezionej..
                                    }

                                    if(isChecked) //wybran więc trzeba ją usunąć z listy..
                                    {
                                        console.log("grupa wybrana,", val);                    
                                        setRowX( {...row, [tabName]:newListGrupWithoutSelected } );   
                                        return;
                                    }else
                                    {
                                        console.log("grupa nie wybrana,", val); 
                                        newListGrupWithoutSelected.push( "" + val + "" );                   
                                        setRowX( {...row, [tabName]:newListGrupWithoutSelected } );   
                                        return;
                                    }


                                    return;
                                }





                    var tRef = row[tabName];

                   // console.log("tRef", tRef);

                    if(  tRef[tabInx]["selected"] == "0"   )
                    {
                    tRef[tabInx]["selected"] = "1";
                    }else tRef[tabInx]["selected"] = '0';


                    tmpRow[tabName] = tRef;     
                    setRowX(  JSON.parse(JSON.stringify(tmpRow)) );  
        
                    //setRowX( {...row, [tabName]:tRef } );   
                    return;
                }
        
            
                tmpRow[filedName] = val;
                tmpRow[filedName+"_valid"] = correct;         
                setRowX(  JSON.parse(JSON.stringify(tmpRow)) );    
            
                //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );    
    

            
            }   
        
        
            const goNextNew = () => {
                console.log("goNext");
                saveData();
            }
    
        const saveData = () => {

 

            if(!valChecker(row))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }
        

            if( row.grupy.length < 1)
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Wybierz min. jedną grupę.' ,  "ok"  ,null); 
                return;
            }


    
            props.mainView.setProgress(-2);
    
            var req = row;
    
            fetch( Config.url + '/rest_v1_news,kalendarz_zapisz', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {             
                        
                        props.mainView.setProgress(-1);
    
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                           // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                           setErrTab(res.result);
                        }else
                        if(res.status != undefined && res.status == "OK")
                        {
                            props.mainView.showDialog( "Sukces",  "Informacje zostały zapisane", "ok" ,  (rex)=>{
                                props.onSukcess();
                            });                      
                          
                        }else
                        {
                            props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                        }
                       
             } )
             .catch(err => {   
                        props.mainView.setProgress(-1);       
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
             });
                       
    
             return false;
    
        }
     


   

 const getCallDetails = () => {

        
        var req = {
            id: props.id,
        };

        fetch( Config.url + '/rest_v1_news,kalendarz_det', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    setRowX(res.result); 
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;
    }

        
    const getGroup = () => {

        
        var req = {
        
        };

        fetch( Config.url + '/rest_v1_emps,kid_group', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    setPlGr(res); 
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;
    }


    if(plgr == null)
        {        
            getGroup();             
            
            if(props.id >0 && row.id < 0)   
                {
                    getCallDetails();
                }

            return <div>
                .....
            </div> 
        }


    
       
 
        return (
                 <div className="view_content">

                        <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>
                    
                        
                        <form className="eForm bg_center">

                                     


                                    <div className="form_tab">

                                        

                                           <div className="form_tab_title">Informacje ogólne:</div>

                                                                
                                                            <div className="form_control">
                                                                        <div className="fieldName">Data</div>
                                                                        <InputDate   userData={props.userData} value={row.dzien} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="dzien" placeholder={"Dzień:"} className='  ' req='1' firstUp="0" />
                                                            </div>

                                                            <div className="form_control">
                                                                        <div className="fieldName">Godzina</div>
                                                                        <InputTime   userData={props.userData} value={row.godzina_wydarzenia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina_wydarzenia" placeholder={"Godzina:"} className='  ' req='1' firstUp="0" />
                                                            </div>

                                                            <div className="form_control">
                                                                        <div className="fieldName">Tytuł* (np. wyjście na spacer)</div>
                                                                        <InputText   userData={props.userData} value={row.temat_dnia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="temat_dnia" placeholder={"Tytuł:"} className=' w300 ' req='1' firstUp="0" />
                                                            </div>


                                                            <div className="form_split"></div>

                                                                  <div className="form_control">
                                                                        <div className="fieldName">Forma aktywności</div>
                                                                        <InputTextArea   userData={props.userData} value={row.forma_aktywnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="forma_aktywnosci" placeholder={"Forma aktywności:"} className=' w300 ' req='1' firstUp="0" />
                                                                  </div>

                                                                  <div className="form_control">
                                                                        <div className="fieldName">Cel dnia</div>
                                                                        <InputTextArea   userData={props.userData} value={row.cel_dnia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="cel_dnia" placeholder={"Cel dnia:"} className=' w300 ' req='0' firstUp="0" />
                                                                  </div>


                                                                  <div className="form_control">
                                                                        <div className="fieldName">Wymagane (ciepłe ubranie, buty na przebranie, ...)</div>
                                                                        <InputTextArea   userData={props.userData} value={row.wymagane} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="wymagane" placeholder={"Wymagane:"} className='   ' req='0' firstUp="0" />
                                                                  </div>

                                                                  <div className="form_control">
                                                                        <div className="fieldName">Przypomnienie dla rodziców</div>
                                                                        <InputCombo items={ [ {v:'0',title:'Nie'},   {v:'1',title:'Tak, dzień wcześniej (9:00)'},    ] }   userData={props.userData} value={row.przypomnij_dzien_przed} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="przypomnij_dzien_przed" placeholder={":"} className='   ' req='0' firstUp="0" />
                                                                  </div>


                                    </div>

                                    <div className="form_tab">
                                           <div className="form_tab">
                                                <div className="form_tab_title">Powiązane grupy:</div>
                                                
                                                    {
                                                        plgr.result.map( (item, ix) => {                                        

                                                            
                                                                var ccc = false;

                                                                for(var p=0; p<row.grupy.length; p++)
                                                                {
                                                                    if(    row.grupy[p]  ===   item.id  )   
                                                                        {
                                                                            ccc = true; 
                                                                            break;                                                     
                                                                        }                                                   
                                                                }
                                                                                                            
                                                                return (
                                                                    <div className="form_control">     
                                                                                                                    
                                                                        <InputChecbox  title={item.nazwa}  err={errTab}  userData={props.userData}  checked={ccc} value={item.id} valChange={valChangeListener}  name={ "grupy@"+ix  }   className=' ' req='0' />
                                                                    </div>
                                                                )

                                                        } )
                                                    }
                                            </div>
                                    </div>

 


                                    <div className="form_split"></div>

                                    <div className="form_btn">
                                            <div className="btn" onClick={saveData}>zapisz</div>
                                            &nbsp;&nbsp;
                                            <div className="btn" onClick={props.onBack}    > anuluj</div>
                                    </div>


                        </form>

                </div>
        )
}


export default CalendarYearForm;